import React, { useEffect, useRef, useState, Suspense } from "react";
import { Switch, Route } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";
//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected, AccessRoute } from "./AuthProtected";
import { ToastContainer } from "react-toastify";
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";

import { isEmpty } from "lodash";
import metadata from "../common/metadata.json";
import HeartBeat from "../Components/HeartBeat";
import GpsTracking from "../Components/gpsTracking";
import ChatCrmitPopup from "../Components/popUpComponents/ChatCrmitPopup";
import NotFound from "../pages/NotFound";
import ChunkErrorBoundary from "../Components/Common/ChunkErrorBoundary";
import LoadingSpinner from "../Components/Common/Spinner";
import UpdateAvailableBanner from "../Components/Common/UpdateAvailableBanner";

// Task 24890 - a public route silently shadows an auth-protected route of the
// same name: the public branch of the outer Switch below is tested first, and
// react-router v5 matches paths case-insensitively. That is how the loyalty
// portal's legacy /loyalty-dashboard alias hid the admin /Loyalty-dashboard
// screen. Shout about the next one in development, before it ships.
if (process.env.NODE_ENV === "development") {
  const authPaths = new Set(
    authProtectedRoutes.map((r) => String(r.path).toLowerCase())
  );
  const shadowed = publicRoutes
    .map((r) => r.path)
    .filter((p) => authPaths.has(String(p).toLowerCase()));
  if (shadowed.length) {
    // eslint-disable-next-line no-console
    console.warn(
      "[Routes] these public routes shadow an auth-protected route of the same name (casing is ignored):",
      shadowed
    );
  }
}

const Index = () => {
  const tawkMessengerRef = useRef();
  const { buildMajor, buildMinor, buildRevision, buildTag, buildDate } =
    metadata;
  const version = `${buildMajor}.${buildMinor}.${buildRevision}  Updated ${buildDate}`;
  const availablePublicRoutesPaths = publicRoutes.map((r) => r.path);
  const availableAuthRoutesPath = authProtectedRoutes.map((r) => r.path);
  const localData = JSON?.parse(
    localStorage.getItem("authUser")
  )?.get_user_data;

  useEffect(() => {
    if (isEmpty(localData)) return;
    tawkMessengerRef?.current?.visitor({
      name: localData?.User_UserFirstName + " " + localData?.User_UserLastName,
      email: localData?.User_Email,
      version: version,
    });
  }, []);

  //console log current path I am on

  //check if cerrent pathname containts widget or restaurant-reservation

  return (
    <React.Fragment>
      {localData?.User_Id && (
        <div>
          <TawkMessengerReact
            propertyId="648b2ec9cc26a871b022c321"
            widgetId="1h2vqthso"
            ref={tawkMessengerRef}
            // pass default name
          />{" "}
          {/*<GpsTracking />*/}
        </div>
      )}
      {/*<MarkerIo />*/}
      <ToastContainer />
      <Switch>
        <Route path={availablePublicRoutesPaths}>
          <NonAuthLayout>
            {/* Route components are lazy (see allRoutes.js), so a Suspense
                boundary is required. It sits around the Switch, never between
                the Switch and its Routes: React Router v5 only inspects its
                direct children's path props when matching. */}
            <ChunkErrorBoundary>
              <Suspense fallback={<LoadingSpinner size="medium" />}>
                <Switch>
                  {publicRoutes.map((route, idx) => (
                    <Route
                      path={route.path}
                      component={route.component}
                      key={idx}
                      exact={false}
                    />
                  ))}
                </Switch>
              </Suspense>
            </ChunkErrorBoundary>
          </NonAuthLayout>
        </Route>

        <Route path={availableAuthRoutesPath}>
          {/* Task 24831 - the guard needs to know which paths are public so it
              can refuse to log out, redirect, or 404 one of them. */}
          <AuthProtected publicPaths={availablePublicRoutesPaths}>
            <ChatCrmitPopup />
            <HeartBeat />
            {/* Change #100012 - tells a logged-in tab a newer build is live. */}
            <UpdateAvailableBanner />

            <VerticalLayout>
              {/* Suspense sits inside VerticalLayout so the sidebar and header
                  stay on screen while a page chunk downloads. */}
              <ChunkErrorBoundary>
                <Suspense fallback={<LoadingSpinner size="medium" />}>
                  <Switch>
                    {authProtectedRoutes.map((route, idx) => (
                      <AccessRoute
                        path={route.path}
                        component={route.component}
                        key={idx}
                        exact={true}
                      />
                    ))}
                    {/* Catch-all: an unknown URL (e.g. /taskssdfsdfd) still enters
                        this auth block because availableAuthRoutesPath includes "/"
                        (non-exact), so it must be caught here rather than in the
                        outer Switch, or it would render a blank page. */}
                    <Route component={NotFound} />
                  </Switch>
                </Suspense>
              </ChunkErrorBoundary>
            </VerticalLayout>
          </AuthProtected>
        </Route>
      </Switch>
    </React.Fragment>
  );
};

export default Index;
